import * as angular from 'angular';
import { NgModule } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Composants Material utilises
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Composants graphiques d'Aurora
import { ExtendedFilterableSelectComponent } from './components/extended-filterable-select.component';
import { FilterableSelectComponent } from './components/filterable-select.component';
import { MultiExtendedFilterableSelectComponent } from './components/multi-extended-filterable-select.component';
import { MultiExtendedFilterableSelectComponent2 } from './components/multi-extended-filterable-select2.component';
import { MultiFilterableSelectComponent } from './components/multi-filterable-select.component';
import { NoInputResetFilterableSelectComponent } from './components/no-input-reset-filterable-select.component';
import { MultiEditableFilterableSelectComponent } from './components/multi-editable-filterable-select.component';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		
		MatAutocompleteModule,
	],
	providers: [
	],
	declarations: [
		ExtendedFilterableSelectComponent,
		FilterableSelectComponent,
		MultiExtendedFilterableSelectComponent,
		MultiExtendedFilterableSelectComponent2,
		MultiFilterableSelectComponent,
		MultiEditableFilterableSelectComponent,
		NoInputResetFilterableSelectComponent,
	],
	exports: [
		ExtendedFilterableSelectComponent,
		FilterableSelectComponent,
		MultiExtendedFilterableSelectComponent,
		MultiExtendedFilterableSelectComponent2,
		MultiFilterableSelectComponent,
		MultiEditableFilterableSelectComponent,
		NoInputResetFilterableSelectComponent,
	],
	entryComponents: [
		FilterableSelectComponent,
	]
})
export class FilterableSelectModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('filterableSelect',
		downgradeComponent({ component: FilterableSelectComponent })
	) //
